const apiEndpoint = import.meta.env.VITE_BACKEND_API_ENDPOINT

export const isProduction =
  apiEndpoint?.includes('api.lucie-la-cabane-autonome.fr') === true &&
  !apiEndpoint.includes('staging')
